var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inventory',{attrs:{"product":"KVKK"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }